import { render, staticRenderFns } from "./moreperson.vue?vue&type=template&id=35c5d962&scoped=true"
import script from "./moreperson.vue?vue&type=script&lang=js"
export * from "./moreperson.vue?vue&type=script&lang=js"
import style0 from "./moreperson.vue?vue&type=style&index=0&id=35c5d962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c5d962",
  null
  
)

export default component.exports